// extracted by mini-css-extract-plugin
export default {"modal":"add-player-clip_modal__rww2t"};